import { useAppDispatch, useAppSelector } from "@/config/store";
import { IEdoVideostorePost } from "@/shared/model/edo-videostore-post.model";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui";
import { useEffect } from "react";
import { Translate } from "react-jhipster";
import { deleteEntity } from "../../../shared/reducers/entities/edo-videostore-post.reducer";

interface IDeleteVideostorePostProps {
  videostorePost: IEdoVideostorePost;
  open: boolean;
  onClose: () => void;
}

const DeleteVideostorePost = (props: IDeleteVideostorePostProps) => {
  const dispatch = useAppDispatch();
  const { updateSuccess } = useAppSelector<EntityState<IEdoVideostorePost>>(
    (state) => state.edoVideostorePost
  );
  const { videostorePost, open, onClose: handleClose } = props;

  const confirmDelete = () => {
    dispatch(deleteEntity(videostorePost.id));
  };

  useEffect(() => {
    if (updateSuccess) handleClose();
  }, [updateSuccess, handleClose]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
          </DialogTitle>
        </DialogHeader>
        {!videostorePost ? (
          <div className="flex justify-center py-4">
            <span className="h-5 w-5 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          </div>
        ) : (
          <p className="text-sm text-[var(--color-mockup-text-mid)]">
            <Translate
              contentKey="edocendoApp.edoVideostorePost.delete.question"
              interpolate={{ nome: videostorePost.title }}
            >
              Are you sure you want to delete this EdoPostVideostore?
            </Translate>
          </p>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            <Translate contentKey="entity.action.delete">Delete</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteVideostorePost;
